module.exports = __webpack_public_path__ + "static/media/ic_more.e4aeb698.svg";